import { render } from "./OverdueReservationsReport.vue?vue&type=template&id=10d4ace0"
import script from "./OverdueReservationsReport.vue?vue&type=script&lang=js"
export * from "./OverdueReservationsReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__